module.exports = "<h2>Calendar Events</h2>\r\n\r\nCalendar Events here..."


//////////////////
// WEBPACK FOOTER
// ./src/app/home/calendar.component.html
// module id = 1136
// module chunks = 1